import React, { useEffect, useState } from "react";
import { ANIM_PROPS, stripAnimProps, FMModule, TAGS } from "./lazy-motion-utils";

type AnyProps = Record<string, unknown>;

let cachedFM: FMModule = null;

export function LazyDiv(props: AnyProps){
  const { children } = props;
  const [loaded, setLoaded] = useState(!!cachedFM);

  useEffect(()=>{
    if(!cachedFM){
      import("framer-motion").then((m) => {
        cachedFM = m;
        setLoaded(true);
      }).catch(()=>{
        // ignore
      });
    }
  },[]);

  if(loaded && cachedFM && cachedFM.motion && cachedFM.motion.div){
    const MotionDiv = cachedFM.motion.div;
    return <MotionDiv {...(props as unknown)}>{children}</MotionDiv>;
  }

  return <div {...stripAnimProps(props)}>{children}</div>;
}

export function LazyAnimatePresence({ children, ...props }: AnyProps){
  const [loaded, setLoaded] = useState(!!cachedFM);

  useEffect(()=>{
    if(!cachedFM){
      import("framer-motion").then((m) => {
        cachedFM = m;
        setLoaded(true);
      }).catch(()=>{});
    }
  },[]);

  if(loaded && cachedFM && cachedFM.AnimatePresence){
    const AP = cachedFM.AnimatePresence;
    return <AP {...(props as unknown)}>{children}</AP>;
  }

  return <>{children}</>;
}
export default {} as Record<string, React.ElementType>;
